import {
  boolean,
  date,
  domain,
  email,
  float,
  fromList,
  guid,
  subList,
  integer,
  paragraph,
  sentence,
  string,
  url,
  word
} from './base.js';
import listOf from './list-of.js';
import simpleObject from './simple-object.js';
import objectWithKeys from './object-with-keys.js';

export default {
  string,
  word,
  sentence,
  paragraph,
  integer,
  float,
  boolean,
  url,
  domain,
  guid,
  email,
  date,
  simpleObject,
  objectWithKeys,
  listOf,
  fromList,
  subList
};
